/* global FB */
/* eslint no-undef: "error" */
const hasRequiredFBPermissions = () => FB.api('/me/permissions', ({ data = {} }) => !!data.installed)

// const SOCIAL_APP_PROXY_WINDOW = 'socialAppProxy'

const facebookLogin = ({
  tracker, fbServices, usingProxy, i18n, countryCodes,
  clientConfig: {
    suppressActiveWaiver,
    useCustomizeWaiver,
    waiverAttachementObjectIds,
  },
  ...restOuter
}) => {
  let errorMsg = i18n('passport.error.server.default')
  const submitAccessToken = (fbat, callbacks) => {
    if (usingProxy) {
      // TODO
    }
    tracker({
      eventName: 'FBConnectConfirmation',
      widget: 'signin',
      pageType: 'sign in',
      explicitName: 'sign in facebook confirmation',
      eventTracking: 'facebook connect',
    })

    const facebookSign = params => {
      fbServices.facebookLogin({
        params: {
          fbat,
          countriesInfo: countryCodes,
          suppressActiveWaiver,
          useCustomizeWaiver,
          waiverAttachementObjectIds,
          ...params,
        },
        resolve: ({
          status, message, ...rest
        }) => {
          if (status === 'SUCCESS') {
            callbacks[message] && callbacks[message](rest)
          } else if (status === 'WAIVER_EXPIRED') {
            callbacks.handleWaiverExpired({
              response: { ...rest, ...restOuter },
              facebookSign,
            })
          } else if (status === 'NO_COUNTRY_CODE') {
            callbacks.handleNoCountryCode({
              response: { ...rest, ...restOuter },
              facebookSign,
            })
          } else if (status === 'COPPA') {
            callbacks.handleCoppa({
              ...rest,
            })
          } else if (status === 'FAILURE' && message) {
            if (message === 'ACCOUNT_ALREADY_BOUND') {
              errorMsg = i18n('passport.facebook.bindAccount.notice')
            } else {
              errorMsg = message || i18n('passport.error.server.default')
            }
            callbacks.handleError({ errorMsg })
          } else if (status === 'PSW_NOT_QUALFIED') {
            // PSW_NOT_QUALFIED is an invalid branch for facebook login
            callbacks.handleError({ errorMsg: i18n('passport.error.server.default') })
          } else {
            callbacks.handleError({ errorMsg })
          }
        },
        reject: ({ message }) => {
          errorMsg = message || errorMsg
          callbacks.handleError({ errorMsg })
        },
      })
    }

    facebookSign()
  }

  return (callbacks, handlers) => {
    tracker({
      eventName: 'FBConnect',
      widget: 'signin',
      pageType: 'sign in',
      explicitName: 'sign in facebook',
    })

    FB.getLoginStatus(({ status, authResponse }) => {
      if (status === 'connected' && hasRequiredFBPermissions()) {
        submitAccessToken(authResponse.accessToken, callbacks, handlers)
      } else {
        FB.login(({ authResponse: reloginAuthResponse }) => {
          if (reloginAuthResponse && reloginAuthResponse.accessToken) {
            submitAccessToken(reloginAuthResponse.accessToken, callbacks, handlers)
          }
        }, { scope: 'email' })
      }
    })
  }
}

export default facebookLogin
